import React from 'react';
import { cn } from '@mellify/ui';
import { Sidebar } from '../components/navigation/Sidebar';
import { MobileMenu } from '../components/navigation/MobileMenu';
import { useSidebarStore } from '../stores/sidebarStore';

export interface AppLayoutProps {
  /** Main content */
  children: React.ReactNode;
  /** Currently active route path for sidebar highlighting */
  activePath?: string;
  /** Additional className for the main content area */
  className?: string;
}

export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  activePath = '/dashboard',
  className,
}) => {
  // Access store to keep reactivity, but we don't need the value directly here
  useSidebarStore();

  return (
    <div className="flex h-screen overflow-hidden bg-dark-50 dark:bg-dark-950">
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex lg:shrink-0">
        <Sidebar activePath={activePath} />
      </div>

      {/* Mobile Menu */}
      <MobileMenu activePath={activePath} />

      {/* Main content area */}
      <main
        className={cn(
          'flex-1 flex flex-col overflow-hidden transition-all duration-300 ease-smooth',
          className
        )}
      >
        {children}
      </main>
    </div>
  );
};

AppLayout.displayName = 'AppLayout';